import api from '../api'

const state = {
  all: [],
  usageStats: null,
  client: null
}

const actions = {
  getUsageStats: ({ state, commit }, form) => {
    let {id, to, from} = form
    return api.getUsageStats(id, to, from).then(stats => {
      return commit('setUsageStats', stats)
    })
  },
  getClients: ({ state, commit }, includeAssociateUsers) => {
    return api.getAllClients(includeAssociateUsers).then(clients => {
      return commit('setAllClients', clients)
    })
  },
  getClient: ({ state, commit }, id) => {
    return api.getSingleClient(id).then(client => {
      return commit('setSingleClient', client)
    })
  },
  getClientOverview: ({ state, commit }, id) => {
    var params = {params: {'include_invoices': 1}}
    return api.getSingleClient(id, params).then(client => {
      return commit('setSingleClient', client)
    })
  },
  updateClient: ({ state, commit }, data) => {
    return api.updateSingleClient(data).then(client => {
      return commit('setSingleClient', client)
    })
  },
  addClient: ({ state, commit }, data) => {
    return api.addSingleClient(data).then(client => {
      return commit('setSingleClient', client)
    })
  },
  deleteClient: ({ state, commit }, id) => {
    return api.deleteSingleClient(id).then(() => {
      return commit('setSingleClient', null)
    })
  },
  uploadImage: ({ state, commit }, data) => {
    return api.uploadSingleImage(data).then((user) => {
      return commit('setSingleClient', user)
    })
  },
  deleteImage: ({ state, commit }, id) => {
    return api.deleteSingleImage(id).then((user) => {
      return commit('setSingleClient', user)
    })
  }
}

const mutations = {
  setAllClients (state, clients) {
    state.all = clients
  },
  setUsageStats (state, stats) {
    state.usageStats = stats
  },
  setSingleClient (state, client) {
    state.client = client
  },
  resetSingleClient (state) {
    state.client = null
  }
}

const getters = {
  all: state => {
    return state.all
  },
  client: state => {
    return state.client
  },
  stats: state => {
    return state.usageStats
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/clients.js